import { FaEdit, FaPlus } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";

const CategoryCard = ({ selectedCategory, onClick, title }) => {
    const hasSelection = !!selectedCategory;
    return (
        <CardContainer
            $hasSelection={hasSelection}
            onClick={onClick}
            type="button"
        >
            <CardContent>
                <CategoryName $hasSelection={hasSelection}>
                    {selectedCategory ? selectedCategory.label || selectedCategory.name || selectedCategory.roomNum || selectedCategory.bankName : `Please select a ${title}`}
                </CategoryName>
                <IconWrapper $hasSelection={hasSelection}>
                    {hasSelection ? <MdEdit className="w-3 h-3" /> : <FaPlus className="w-3 h-3" />}
                </IconWrapper>
            </CardContent>
        </CardContainer>
    );
};

// Styled Components
const CardContainer = tw.button`w-full group relative overflow-hidden rounded-md px-2 py-2 transition-all duration-300 ease-out border border-gray-200 bg-white h-12`;
const CardContent = tw.div`flex justify-between items-center gap-3`;
const CategoryName = tw.div`text-sm transition-colors truncate text-gray-600 pl-2`;
const GroupBadge = tw.span`inline-flex items-center px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-medium mt-1`;
const IconWrapper = tw.div`ml-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;

export default CategoryCard;